import AddIcon from '@mui/icons-material/Add';
import Dropdown from '../../../Components/Form/Inputs/Dropdown';
import IconMenuHorizontalDropdown, { IIconMenuHorizontalDropdownOption } from '../../../Components/Form/Inputs/IconMenuHorizontalDropdown';
import { SelectInputOption } from '../../../Components/Form/Inputs/SelectInput';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from './Margin.module.scss';

interface CustomCalculatorBarProperties {
    savedCalculatorOptions: SelectInputOption<string>[];
    selectedSavedCalculatorGuid: string | undefined;
    onSelectSavedCalculator: (value: string) => void;
    calculatorFlyoutOptions: IIconMenuHorizontalDropdownOption[];
    isVisible: boolean;
    disabled: boolean;
}

const CustomCalculatorBar = (properties: CustomCalculatorBarProperties): JSX.Element | null => {
    const [translations] = useLanguage();
    if (!properties.isVisible) {
        return null;
    }

    return (
        <>
            {properties.savedCalculatorOptions.length > 0 && (
                <div className={styles.margin_dropdown}>
                    <Dropdown
                        label={translations.risk.margin.headers.customCalculatorSavedCalculators}
                        value={properties.savedCalculatorOptions.find((x) => x.value === (properties.selectedSavedCalculatorGuid ?? ''))?.value ?? ''}
                        options={properties.savedCalculatorOptions}
                        handleOptionChange={properties.onSelectSavedCalculator}
                        disabled={properties.disabled}
                        track={{ eventCategory: 'MarginCalculator', eventAction: 'SavedCalculatorChanged' }}
                    />
                </div>
            )}
            <div className={styles.margin_calculator_flyout_container}>
                <IconMenuHorizontalDropdown
                    icon={<AddIcon fontSize="small" />}
                    options={properties.calculatorFlyoutOptions}
                    menuClassName={styles.margin_calculator_flyout_menu}
                    itemClassName={styles.margin_calculator_flyout_item}
                    track={{ eventCategory: 'MarginCalculator', eventAction: 'CalculatorFlyout' }}
                />
            </div>
        </>
    );
};

export default CustomCalculatorBar;
